import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable,throwError } from 'rxjs';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(private loaderService: NgxUiLoaderService) { }

  service_count = 0;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.service_count++;
    this.loaderService.start();
    return next.handle(request).pipe(tap(
      (req) => {
        if (req instanceof HttpResponse) {
          this.service_count--;
          if (this.service_count === 0) {
            this.loaderService.stop();
        }
        }
      },
      (error) => {
        this.loaderService.stop();
      }
    )).pipe(catchError((err:any) => {
      if (err instanceof HttpErrorResponse) {
          if (!err.ok) {
            this.service_count--;
            if (this.service_count === 0) {
              this.loaderService.stop();
          }
          }
      }
      return throwError(err);
}));;
  }
}
